import { CardTemplate } from 'types/story';
import { CardEvent } from 'admin/components/pages/Story/Flow/Connector/ConnectorSvg/utils';
import { COMPONENTS } from 'client/components/common/BuildingBlocks';
import { COMPONENT_TYPE as TYPE } from 'common/constants';
import { generateCardId } from 'utils/facades/utils';

export function defaultTemplate(): CardTemplate {
	return {
		id: '',
		name: 'Blank page',
		subtitle: 'Blank template.',
		description: 'Blank template to build your card from scratch.',
		editor: {
			card: {
				_id: generateCardId(),
				elements: [
					COMPONENTS[TYPE.FLOAT_ABOVE]().model,
					COMPONENTS[TYPE.CONTENT]().model,
					COMPONENTS[TYPE.FLOAT_BELOW]().model,
					COMPONENTS[TYPE.CARD]().model,
				],
				settings: {},
				events: [CardEvent()],
			},
		},
		metadata: {
			storySettings: {},
			storyId: '',
			cardId: '',
			clientStoryId: '',
			version: process.env.VERSION as string,
			defaultPlatform: 'default',
		},
		type: 'card',
		language: '',
		categories: [],
	};
}
